module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-32.11344040.png";